import type { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { SKIP_API_URL } from '../auth/auth.context';
import { APP_CONFIG } from '../config/app-config';
import { isAbsoluteUrl } from './absolute-url';

export const apiUrlInterceptor: HttpInterceptorFn = (request, next) => {
  const { apiUrl } = inject(APP_CONFIG);

  if (request.context.get(SKIP_API_URL) || isAbsoluteUrl(request.url)) {
    return next(request);
  }

  const base = apiUrl.endsWith('/') ? apiUrl.slice(0, -1) : apiUrl;
  const path = request.url.startsWith('/') ? request.url : `/${request.url}`;

  return next(request.clone({ url: `${base}${path}` }));
};
